export function timeAgo(iso, language = "en") {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "Date unavailable";
  const diff = Math.max(0, Date.now() - then);
  const m = Math.floor(diff / 60000);
  if (m < 1) return language === "id" ? "baru saja" : "just now";
  if (m < 60) return language === "id" ? `${m} menit lalu` : `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return language === "id" ? `${h} jam lalu` : `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return language === "id" ? `${d} hari lalu` : `${d}d ago`;
  return formatDate(iso, language);
}

export function formatDate(iso, language = "en") {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(language === "id" ? "id-ID" : "en-US", { year: "numeric", month: "long", day: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return 'Date unavailable';
  return date.toLocaleString("en-US", { year: 'numeric', month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: 'short' });
}
